import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {labels} from '../../util/utils';

export default function FormUsersReducer(state = initialstate.formUsers, action) {
	switch (action.type) {
		case types.GET_FORM_USERS: {
			let users;
			if (action.debug) {
				users = getTestdata();
			} else {
				users = action.response;
			}

			const options = [];

			const internalOptions =
				users && users.internal && users.internal.length > 0
					? users.internal.map((user) => {
							return {label: user.fullName, value: user.id};
					  })
					: [{label: labels.noneAvailable, isDisabled: true}];

			const internalGroup = {
				label: labels.eyInternal,
				options: internalOptions
			};

			options.push(internalGroup);

			if (users.externalGroups?.length > 0) {
				const clients = [];

				users.externalGroups.map((group) => {
					const newGroup = {
						label: group.clientGroupName,
						options: []
					};
					group.users.map((user) => {
						newGroup.options.push({
							label: user.fullName,
							value: user.id
						});
					});

					options.push(newGroup); //Delete only if uncommenting the lines below.

					// In case react select now supports nested grouping, just uncomment the following lines.
					// clients.push(newGroup);
				});

				// const externalGroups = {
				// 	label: 'Client',
				// 	options: clients
				// };

				// options.push(externalGroups);
			}

			return options;
		}
		default:
			return state;
	}
}

// foreach group

// nuevoGrupo = {label: group.name
// options: []}

// foreach user in group.users
// nuevoGrupo.options.push(...)

// groups.push(nuevoGrupo)

function getTestData() {
	return {
		internalUsers: [
			{
				id: 'DE4CF9F8-5B71-EB11-B566-000D3A22324C',
				firstName: 'Bill',
				lastName: 'Newton',
				userInital: 'BN',
				emailAddress: 'Bill.Newton@ey.com',
				isExternal: false,
				clientGroupId: null,
				clientGroupName: null
			},
			{
				id: 'E7886A97-8A6F-EB11-B566-000D3A22324',
				firstName: 'Algun Thomas',
				lastName: 'Dyer',
				userInital: 'TD',
				emailAddress: 'Thomas.A.Dyer@ey.com',
				isExternal: false,
				clientGroupId: null,
				clientGroupName: null
			}
		],
		externalUsers: [
			{
				id: 1440,
				name: 'Client group 1440',
				users: [
					{
						id: '878EF141-1B25-4BDE-B684-2B0234E75DE0',
						firstName: 'Shannon',
						lastName: 'Aufderhar',
						userInital: 'SA',
						emailAddress: 'Shannon_Aufderhar81@hotmail.com',
						isExternal: false,
						clientGroupId: 1440,
						clientGroupName: 'Client group 1440'
					}
				]
			}
		]
	};
}
